module.exports = __webpack_public_path__ + "static/media/stofferingen-41.1866dc29.jpg";